import { te } from "date-fns/locale";
import { v4 as uuid } from "uuid";
interface IPlaceholder {
  journeyId: string;
  startStepId: string;
  messageStepId: string;
  exitStepId: string;
}

interface IConvertToJounreyVisualLayout {
  journeyId: string;
  startStepId: string;
  messageStepId: string;
  exitStepId: string;
  template?: {
    type: 'sms' | 'email' | 'push' | 'whatsapp',
    selected: {
      id: number,
      name: string
    }
  }
}

export const convertToJounreyVisualLayout = (params: IConvertToJounreyVisualLayout) => {
  const { template } = params

  const nodes = [
    {
      "id": uuid(),
      "data": {
        "stepId": params.startStepId,
      },
      "type": "start",
      "position": {
        "x": 0,
        "y": 0
      },
      "selected": false
    },
    {
      "id": uuid(),
      "data": {
        "type": "message",
        "template": Boolean(template) ? template : undefined,
        "customName": template ? `${template.type} 1` : 'Message 1',
        "stepId": params.messageStepId,
        "showErrors": true
      },
      "type": "message",
      "position": {
        "x": 0,
        "y": 114
      },
      "selected": false
    },
    {
      "id": uuid(),
      "type": "exit",
      "data": {
        "stepId": params.exitStepId,
        "showErrors": true
      },
      "position": {
        "x": 0,
        "y": 228
      },
      "selected": false
    }
  ]
  const edgesItems = [
    {
      id: nodes[0].id + "-" + nodes[1].id,
      type: "primary",
      source: nodes[0].id,
      target: nodes[1].id
    },
    {
      id: nodes[1].id + "-" + nodes[2].id,
      type: "primary",
      source: nodes[1].id,
      target: nodes[2].id
    }
  ]

  return {
    nodes,
    edges: edgesItems,
    triggers: [],
  }
}

interface IJourneyPayload {
  id: string
  name: string
  selectedSegmentId: string
}

export const toJourneyPayloadTemplate = (journey: IJourneyPayload) => {
  return {
    "id": journey.id,
    "name": journey.name,
    "inclusionCriteria": {
      "type": "conditional",
      "query": {
        "statements": [
          {
            "type": "Segment",
            "segmentId": journey.selectedSegmentId
          }
        ]
      }
    },
    "isDynamic": true,
    "journeyEntrySettings": {
      "entryTiming": {
        "type": "WhenPublished"
      },
      "enrollmentType": "CurrentAndFutureUsers"
    },
    "journeySettings": {
      "tags": [],
      "maxEntries": {
        "enabled": false,
        "limitOnEverySchedule": false,
        "maxEntries": "500000"
      },
      "quietHours": {
        "enabled": false,
        "startTime": "00:00",
        "endTime": "08:00",
        "fallbackBehavior": "NextAvailableTime"
      },
      "maxMessageSends": {
        "enabled": false
      }
    }
  }
}